module.exports = __webpack_public_path__ + "static/img/presentation.8102d09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/presentation.png
// module id = RKSE
// module chunks = 0